import format from "date-fns/format";

export default {
	filename(name, date) {
		return `${name} ${format(date, "dd-MMM-yyyy HH.mm")}.mp4`;
	}
};
